<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        @if (!compendiumShortTermRentalFlag) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="compendiums" formControlName="compendiumId" optionLabel="name"
              optionValue="compendiumId" placeholder="Compendium" [filter]="true" filterBy="name" [showClear]="false"></p-dropdown>
              <label for="compendiumId">Compendium</label>
              @for (validation of validationMessages.compendiumId; track validation) {
                <span>
                  @if (form1.get('compendiumId').hasError(validation.type) && (form1.get('compendiumId').dirty || form1.get('compendiumId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }
        @if (compendiumShortTermRentalFlag) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="compendiums" formControlName="compendiumId" optionLabel="name"
              optionValue="compendiumId" placeholder="Compendium" readonly="true" [filter]="true" filterBy="name" [showClear]="false"></p-dropdown>
              <label for="compendiumId">Compendium</label>
              @for (validation of validationMessages.compendiumId; track validation) {
                <span>
                  @if (form1.get('compendiumId').hasError(validation.type) && (form1.get('compendiumId').dirty || form1.get('compendiumId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }

        @if (!compendiumShortTermRentalFlag) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
              optionValue="shortTermRentalId" placeholder="Properties" [filter]="true" filterBy="propertyCode" [showClear]="false"></p-dropdown>
              <label for="shortTermRentalId">Properties</label>
              @for (validation of validationMessages.shortTermRentalId; track validation) {
                <span>
                  @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }

        @if (compendiumShortTermRentalFlag) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
              optionValue="shortTermRentalId" placeholder="Properties" [filter]="true" filterBy="propertyCode" [showClear]="false" readonly="true"></p-dropdown>
              <label for="shortTermRentalId">Properties</label>
              @for (validation of validationMessages.shortTermRentalId; track validation) {
                <span>
                  @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Status"></p-dropdown>
            <label for="Status">Status</label>
            @for (validation of validationMessages.status; track validation) {
              <span>
                @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        <div class="col-lg-12">
          <label for="propertyCompendium"><strong>Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" id="txtHighlight" formControlName="highlightDesc" (ready)="onReady($event)"></ckeditor> -->
            <editor formControlName="description" id="txtHighlight"
                    [init]="{
              							height: 500,
              							base_url: '/tinymce',
              							suffix: '.min',
              							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
                    toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}">
            </editor>
            <!--<label for="txtHighlight">Highlight Description</label>-->
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="locationTypes" formControlName="locationType" optionLabel="name" optionValue="value"
            placeholder="LocationType"></p-dropdown>
            <label for="locationType">LocationType</label>
            @for (validation of validationMessages.locationType; track validation) {
              <span>
                @if (form1.get('locationType').hasError(validation.type) && (form1.get('locationType').dirty || form1.get('locationType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown class="w-100" [options]="locationAreas" formControlName="locationArea" optionLabel="name" optionValue="value"
            placeholder="Location Area"></p-dropdown>
            <label for="locationArea">Location Area</label>
            @for (validation of validationMessages.locationArea; track validation) {
              <span>
                @if (form1.get('locationArea').hasError(validation.type) && (form1.get('locationArea').dirty || form1.get('locationArea').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="featureName" id="featureName" type="text" pInputText>
            <label for="featureName">Feature Name</label>
            @for (validation of validationMessages.featureName; track validation) {
              <span>
                @if (form1.get('featureName').hasError(validation.type) && (form1.get('featureName').dirty || form1.get('featureName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="feature" id="feature" type="text" pInputText>
            <label for="feature">Feature</label>
            @for (validation of validationMessages.feature; track validation) {
              <span>
                @if (form1.get('feature').hasError(validation.type) && (form1.get('feature').dirty || form1.get('feature').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="featureSortOrder" id="featureSortOrder" type="number" pInputText>
            <label for="featureSortOrder">Feature SortOrder</label>
            @for (validation of validationMessages.featureSortOrder; track validation) {
              <span>
                @if (form1.get('featureSortOrder').hasError(validation.type) && (form1.get('featureSortOrder').dirty || form1.get('featureSortOrder').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="featureNameSortOrder" id="featureNameSortOrder" type="number" pInputText>
            <label for="featureNameSortOrder">Feature Name SortOrder</label>
            @for (validation of validationMessages.featureNameSortOrder; track validation) {
              <span>
                @if (form1.get('featureNameSortOrder').hasError(validation.type) && (form1.get('featureNameSortOrder').dirty || form1.get('featureNameSortOrder').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="externalUrl" id="externalUrl" type="text" pInputText>
            <label for="featureNameSortOrder">externalUrl</label>
            @for (validation of validationMessages.externalUrl; track validation) {
              <span>
                @if (form1.get('externalUrl').hasError(validation.type) && (form1.get('externalUrl').dirty || form1.get('externalUrl').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (compendiumShortTermRentalFlag) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!compendiumShortTermRentalFlag) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (compendiumShortTermRentalFlag) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>